module.exports = __webpack_public_path__ + "static/media/sidebar_header.9507c47e.png";